import React, { useState, useEffect } from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment-timezone";

import { dirname } from "../../../util/resourcePath";
import GYAxios from "../../../util/GYAxios";

import DefaultSelect from "../../general/DefaultSelect";
import ReceiptTable from "./ReceiptTable";

import "../admin.css";
import { localTimeToPickerTime, pickerTimeTolocalTime } from "../../../util/momentTimezone";

export const ReceiptContent = () => {
	const directory = dirname();
	const [currentTab, setCurrentTab] = useState("PENDING");
	const [receipts, setReceipts] = useState([]);
	const [pendingReceipts, setPendingReceipts] = useState([]);
	const [outstandingCount, setOutstandingCount] = useState(0);
	const [reload, setReload] = useState(true);

	const [filterCategory, setFilterCategory] = useState("");
	const [filterOptions, setFilterOptions] = useState([]);
	const [filterValue, setFilterValue] = useState("");
	const [previewResults, setPreviewResults] = useState([]);
	const [isLoadingFilters, setIsLoadingFilters] = useState(false);
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [filter, setFilter] = useState(null);

	const minDate = moment("202103", "YYYYMM");
	const maxDate = moment().subtract(1, "month");

	// Select filters
	const values = [
		{
			label: "Select a filter",
			value: "",
		},
		{
			label: "Entity",
			value: "entity_id",
		},
		{
			label: "Client",
			value: "client_id",
		},
		{
			label: "Month",
			value: "dateData",
		},
		{
			label: "Invoice No.",
			value: "invoice_no",
		},
		{
			label: "MSA",
			value: "site_id",
		},
	];

	/**
	 * Fetch all receipts and pending receipts
	 */
	const fetchReceipts = () => {
		let receiptRequest = null;

		switch (filter) {
			case null:
				receiptRequest = GYAxios.get("/receipts/");
				break;

			default:
				if (filter.prop == "invoice_no")
					receiptRequest = GYAxios.get(
						`/receipts/filter/${filter.prop}/like/${filter.value}`
					);
				else if (filter.prop == 'entity_id' && filter.value == 'TH')
					receiptRequest = GYAxios.get(
						`/receipts/filter/operation_status/2`
					);
				else
					receiptRequest = GYAxios.get(
						`/receipts/filter/${filter.prop}/${filter.value}`
					);
				break;
		}

		if (receiptRequest != null) {
			receiptRequest.then((res) => {
				const response = res.data;
				if (!response.error && response.length > 0) {
					const receipts = response;
					const tempReceipts = [...response];
					const invoiceNumbers = tempReceipts.map(
						(receipt) => receipt.invoiceNo
					);

					const param = {
						invoice_no: invoiceNumbers,
					};

					GYAxios.post("/invoice/invoice_no", param).then((invoiceRes) => {
						const invoices = invoiceRes.data;
						if (!invoices.error) handleReceiptsData(invoices, receipts);
						setReload(false);
					});
				} else {
					handlePreviewResults([]);
					setReload(false);
				}
			});
		}
	};

	/**
	 * Match the receipts to the corresponding invoice(s)
	 * @param {array} invoices
	 * @param {array} receipts
	 */
	const handleReceiptsData = (invoices, receipts) => {
		// Re-assign invoice number prop
		invoices = invoices.map((invoice) => {
			invoice = {
				...invoice,
				invoiceNo: invoice.invoice_no,
			};
			delete invoice.invoice_no;
			return invoice;
		});
		// Map receipts to their corresponding invoice
		const receiptArr = receipts.map((receipt) => {
			let corrInv = null;
			// Makro invoices
			if (receipt.invoiceNo.includes("MKO"))
				corrInv = invoices.filter((inv) => inv.invoiceNo === receipt.invoiceNo);
			else
				corrInv = invoices.find((inv) => inv.invoiceNo === receipt.invoiceNo);
			return { invoice: corrInv, receipt: receipt };
		});

		const tempReceiptsArr = [...receiptArr];
		setPreviewResults(tempReceiptsArr);
	};

	/**
	 * Fetch selected filter rows
	 * @param {string} category
	 */
	const fetchFilterOptions = (category) => {
		if (category != "") {
			let uri = "";
			switch (category) {
				case "entity_id":
					uri = "/select/entities/TH";
					break;
				case "client_id":
					uri = "/select/clients/TH";
					break;
				case "invoice_no":
					uri = "/select/invoice-no";
					break;
				case "site_id":
					uri = "/select/site/msa";
				default:
					break;
			}

			if (uri != "") {
				setIsLoadingFilters(true);

				GYAxios.get(uri).then((res) => {
					const response = res.data;
					if (!response.error) {
						let opts = [];

						if (category === "invoice_no") {
							const temp = [...response].map((obj) => {
								const invoiceNo = obj.invoice_no;

								const numberSplit = invoiceNo.split("-");

								// Remove date and document number of invoice
								numberSplit.splice(numberSplit.length - 2, 2);

								const numberString = `${numberSplit.join("-")}-`;

								return numberString;
							});

							const uniqueArr = [...new Set(temp)];
							opts = uniqueArr.map((invoice_no) => ({
								label: invoice_no,
								value: invoice_no,
							}));
						} else if (category === "site_id") {
							const checkApprovalStat = (obj) => {
								if (obj.approvalStatus === 3) {
									return obj
								}
							}
							let temp = response.filter(obj => checkApprovalStat(obj))
							let selections = []
							temp.forEach((obj) => {
								if (obj.company === obj.site_name) {
									selections.push({ label: obj.company, value: obj.site_id })
								} else {
									selections.push({ label: obj.company + " - " + obj.site_name, value: obj.site_id })
								}
							})
							opts = [...new Map(selections.map((opt) => [opt.value, opt])).values()]
						} else {
							opts = response.map((opt) => ({
								label: opt.label,
								value: opt.value,
							}));
						}
						setFilterOptions(opts);
					}
					setIsLoadingFilters(false);
				});
			}
		} else resetFilter();
	};

	/**
	 * Handle receipt preview results
	 * @param {array} previewResults
	 */
	const handlePreviewResults = (previewResults) => {
		const pendingReceipts = previewResults.filter(
			(recObj) =>
				recObj.receipt.paymentDate == null ||
				!isExpired(recObj.receipt.issuedAt)
		);
		const outStandingInvs = previewResults.filter(
			(recObj) => recObj.receipt.paymentDate == null
		);

		setReceipts(previewResults);
		setPendingReceipts(pendingReceipts);
		setOutstandingCount(outStandingInvs.length);
	};

	/**
	 * Reset filters
	 */
	const resetFilter = () => {
		setFilterOptions([]);
		setFilter(null);
		setReload(true);
	};

	/**
	 * Check if payment date of receipt exceeds 1 day
	 * @param {Date} date
	 * @returns boolean
	 */
	const isExpired = (date) => Math.abs(moment(date).diff(moment(), "days")) > 1;

	/**
	 * Handle change of month in month picker
	 * @param {Date} date
	 */
	const handleMonthChange = (date) => {
		const dateobj = moment(date);

		setSelectedMonth(dateobj);
		setFilterValue(dateobj.format("YYYYMM"));
	};

	/**
	 * Handle filter category change
	 * @param {obj} obj
	 */
	const handleFilterChange = (obj) => {
		setFilterCategory(obj.value);
		setFilterValue("");
	};

	useEffect(() => {
		if (reload) fetchReceipts();
	}, [reload]);

	useEffect(() => {
		setSelectedMonth(null);
		setFilterValue("");
		fetchFilterOptions(filterCategory);
	}, [filterCategory]);

	useEffect(() => {
		if (filterCategory != "" && filterValue != "") {
			setFilter({
				prop: filterCategory,
				value: filterValue,
			});

			setReload(true);
		}
	}, [filterCategory, filterValue]);

	useEffect(() => {
		handlePreviewResults(previewResults);
	}, [previewResults]);

	return (
		<div className="perf-table panel panel-default">
			<div className="panel-heading ">
				<Row>
					<Col sm="6" md="6" lg="6">
						<h2 className="panel-title">Receipts Overview</h2>
					</Col>
					<Col sm="6" md="6" lg="6" style={{ textAlign: "right" }}>
						<img
							src={`${directory}/images/reload.png`}
							onClick={() => setReload(true)}
							style={{
								height: "35px",
								cursor: "pointer",
							}}
							alt="logo"
						/>
					</Col>
				</Row>
				<Row>
					<Col md="6"></Col>
					<Col md="3">
						<DefaultSelect
							defaultValue={values[0]}
							options={values}
							customStyle={{
								width: "100%",
							}}
							onChange={handleFilterChange}
						/>
					</Col>
					<Col md="3">
						{filterCategory === "dateData" ? (
							<div id="receipt-month-selector">
								<DatePicker
									minDate={localTimeToPickerTime(minDate.toDate())}
									maxDate={localTimeToPickerTime(maxDate.toDate())}
									value={
										selectedMonth != null
											? moment(filterValue, "YYYYMM")
											: "Select a month.."
									}
									id="receipt-date"
									onChange={date => handleMonthChange(pickerTimeTolocalTime(date))}
									selected={
										selectedMonth != null ? localTimeToPickerTime(selectedMonth.toDate()) : null
									}
									dateFormat="MMMM yyyy"
									showMonthYearPicker
								/>
							</div>
						) : (
							<DefaultSelect
								options={filterOptions}
								isLoading={isLoadingFilters}
								onChange={(obj) => {
									setFilterValue(obj.value);
								}}
								customStyle={{
									width: "100%",
								}}
							/>
						)}
					</Col>
				</Row>
			</div>
			<div id="receipt-container">
				<Tabs
					id="receipt-component"
					className="receipt-tabs"
					activeKey={currentTab}
					onSelect={(k) => setCurrentTab(k)}
				>
					<Tab
						eventKey="PENDING"
						title={
							<span>
								Pending
								<span id="counter">
									&nbsp;<b>{outstandingCount}</b>
								</span>
							</span>
						}
					>
						<ReceiptTable
							tab="PENDING"
							data={pendingReceipts}
							reload={reload}
							setReload={setReload}
						/>
					</Tab>
					<Tab eventKey="ALL" title="All">
						<ReceiptTable
							tab="ALL"
							data={receipts}
							reload={reload}
							setReload={setReload}
						/>
					</Tab>
				</Tabs>
			</div>
		</div>
	);
};
